/****************************************************************************************************
 * MS Forms "FormGroup" resource API Client.
 *
 * @author Dimitris Gkoulis <gkould@gmail.com>
 * @createdAt 21 May 2021
 * @lastModifiedAt Saturday 11 December 2021
 ****************************************************************************************************/

import ApiUrlProvider from '../api-url-provider';
import BaseApiClient from '../base-api-client';

const FormsFormGroupBasicApiClient = {
    createFormGroup (data) {
        const url = ApiUrlProvider.kernelVersionedApi('form-groups');
        return BaseApiClient.post(url, data);
    },
    updateFormGroup (data) {
        const url = ApiUrlProvider.kernelVersionedApi('form-groups');
        return BaseApiClient.put(url, data);
    },
    getFormGroup (id) {
        const url = ApiUrlProvider.kernelVersionedApi('form-groups/' + id);
        return BaseApiClient.get(url);
    },
    deleteFormGroup (id) {
        const url = ApiUrlProvider.kernelVersionedApi('form-groups/' + id);
        return BaseApiClient.delete(url);
    },
    getAllFormGroups (page = 0, size = 10, sortField = 'id', sortDirection = 'desc') {
        const url = ApiUrlProvider.kernelVersionedApi('form-groups');
        return BaseApiClient.get(url, {
            params: {
                page: page,
                size: size,
                sort: sortField + ',' + sortDirection
            }
        });
    }
};

export default FormsFormGroupBasicApiClient;
